import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "tag", "wrapperTag", "children", "onSwiper"],
  _excluded2 = ["tag", "children", "className", "swiper", "zoom", "virtualIndex"];
import "./index.css";
import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { useDomDirection as t } from "@design-system/hooks";
import { isBrowser as i } from "@phx-husky/browser-helpers";
import n from "classnames";
import s from "object-hash";
import l, { useEffect as a, useLayoutEffect as o, useContext as c, createContext as d, forwardRef as p, useState as u, useRef as v } from "react";
import f, { Scrollbar as g } from "swiper";
import { Typography as h } from "@design-system/typography";
import { Button as m } from "@design-system/button";
function b(e) {
  return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
}
function w(e, r) {
  var t = ["__proto__", "constructor", "prototype"];
  Object.keys(r).filter(function (e) {
    return t.indexOf(e) < 0;
  }).forEach(function (t) {
    void 0 === e[t] ? e[t] = r[t] : b(r[t]) && b(e[t]) && Object.keys(r[t]).length > 0 ? r[t].__swiper__ ? e[t] = r[t] : w(e[t], r[t]) : e[t] = r[t];
  });
}
function x() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return e.navigation && void 0 === e.navigation.nextEl && void 0 === e.navigation.prevEl;
}
function E() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return e.pagination && void 0 === e.pagination.el;
}
function _() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
  return e.scrollbar && void 0 === e.scrollbar.el;
}
function P() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
  var r = e.split(" ").map(function (e) {
      return e.trim();
    }).filter(function (e) {
      return !!e;
    }),
    t = [];
  return r.forEach(function (e) {
    t.indexOf(e) < 0 && t.push(e);
  }), t.join(" ");
}
var S = ["modules", "init", "_direction", "touchEventsTarget", "initialSlide", "_speed", "cssMode", "updateOnWindowResize", "resizeObserver", "nested", "focusableElements", "_enabled", "_width", "_height", "preventInteractionOnTransition", "userAgent", "url", "_edgeSwipeDetection", "_edgeSwipeThreshold", "_freeMode", "_autoHeight", "setWrapperSize", "virtualTranslate", "_effect", "breakpoints", "_spaceBetween", "_slidesPerView", "maxBackfaceHiddenSlides", "_grid", "_slidesPerGroup", "_slidesPerGroupSkip", "_slidesPerGroupAuto", "_centeredSlides", "_centeredSlidesBounds", "_slidesOffsetBefore", "_slidesOffsetAfter", "normalizeSlideIndex", "_centerInsufficientSlides", "_watchOverflow", "roundLengths", "touchRatio", "touchAngle", "simulateTouch", "_shortSwipes", "_longSwipes", "longSwipesRatio", "longSwipesMs", "_followFinger", "allowTouchMove", "_threshold", "touchMoveStopPropagation", "touchStartPreventDefault", "touchStartForcePreventDefault", "touchReleaseOnEdges", "uniqueNavElements", "_resistance", "_resistanceRatio", "_watchSlidesProgress", "_grabCursor", "preventClicks", "preventClicksPropagation", "_slideToClickedSlide", "_preloadImages", "updateOnImagesReady", "_loop", "_loopAdditionalSlides", "_loopedSlides", "_loopedSlidesLimit", "_loopFillGroupWithBlank", "loopPreventsSlide", "_rewind", "_allowSlidePrev", "_allowSlideNext", "_swipeHandler", "_noSwiping", "noSwipingClass", "noSwipingSelector", "passiveListeners", "containerModifierClass", "slideClass", "slideBlankClass", "slideActiveClass", "slideDuplicateActiveClass", "slideVisibleClass", "slideDuplicateClass", "slideNextClass", "slideDuplicateNextClass", "slidePrevClass", "slideDuplicatePrevClass", "wrapperClass", "runCallbacksOnInit", "observer", "observeParents", "observeSlideChildren", "a11y", "_autoplay", "_controller", "coverflowEffect", "cubeEffect", "fadeEffect", "flipEffect", "creativeEffect", "cardsEffect", "hashNavigation", "history", "keyboard", "lazy", "mousewheel", "_navigation", "_pagination", "parallax", "_scrollbar", "_thumbs", "virtual", "zoom"];
var y = function y(e, r) {
  var t = r.slidesPerView;
  if (r.breakpoints) {
    var _e = f.prototype.getBreakpoint(r.breakpoints),
      _i = _e in r.breakpoints ? r.breakpoints[_e] : void 0;
    _i && _i.slidesPerView && (t = _i.slidesPerView);
  }
  var i = Math.ceil(parseFloat(r.loopedSlides || t, 10));
  return i += r.loopAdditionalSlides, i > e.length && r.loopedSlidesLimit && (i = e.length), i;
};
function O(e) {
  return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function j(e) {
  var r = [];
  return l.Children.toArray(e).forEach(function (e) {
    O(e) ? r.push(e) : e.props && e.props.children && j(e.props.children).forEach(function (e) {
      return r.push(e);
    });
  }), r;
}
function C(e) {
  var r = [],
    t = {
      "container-start": [],
      "container-end": [],
      "wrapper-start": [],
      "wrapper-end": []
    };
  return l.Children.toArray(e).forEach(function (e) {
    if (O(e)) r.push(e);else if (e.props && e.props.slot && t[e.props.slot]) t[e.props.slot].push(e);else if (e.props && e.props.children) {
      var _i2 = j(e.props.children);
      _i2.length > 0 ? _i2.forEach(function (e) {
        return r.push(e);
      }) : t["container-end"].push(e);
    } else t["container-end"].push(e);
  }), {
    slides: r,
    slots: t
  };
}
function N(e) {
  var r = e.swiper,
    t = e.slides,
    i = e.passedParams,
    n = e.changedParams,
    s = e.nextEl,
    l = e.prevEl,
    a = e.scrollbarEl,
    o = e.paginationEl;
  var c = n.filter(function (e) {
      return "children" !== e && "direction" !== e;
    }),
    d = r.params,
    p = r.pagination,
    u = r.navigation,
    v = r.scrollbar,
    f = r.virtual,
    g = r.thumbs;
  var h, m, x, E, _;
  n.includes("thumbs") && i.thumbs && i.thumbs.swiper && d.thumbs && !d.thumbs.swiper && (h = !0), n.includes("controller") && i.controller && i.controller.control && d.controller && !d.controller.control && (m = !0), n.includes("pagination") && i.pagination && (i.pagination.el || o) && (d.pagination || !1 === d.pagination) && p && !p.el && (x = !0), n.includes("scrollbar") && i.scrollbar && (i.scrollbar.el || a) && (d.scrollbar || !1 === d.scrollbar) && v && !v.el && (E = !0), n.includes("navigation") && i.navigation && (i.navigation.prevEl || l) && (i.navigation.nextEl || s) && (d.navigation || !1 === d.navigation) && u && !u.prevEl && !u.nextEl && (_ = !0);
  if (c.forEach(function (e) {
    if (b(d[e]) && b(i[e])) w(d[e], i[e]);else {
      var _n = i[e];
      !0 !== _n && !1 !== _n || "navigation" !== e && "pagination" !== e && "scrollbar" !== e ? d[e] = i[e] : !1 === _n && r[t = e] && (r[t].destroy(), "navigation" === t ? (d[t].prevEl = void 0, d[t].nextEl = void 0, r[t].prevEl = void 0, r[t].nextEl = void 0) : (d[t].el = void 0, r[t].el = void 0));
    }
    var t;
  }), c.includes("controller") && !m && r.controller && r.controller.control && d.controller && d.controller.control && (r.controller.control = d.controller.control), n.includes("children") && t && f && d.virtual.enabled ? (f.slides = t, f.update(!0)) : n.includes("children") && r.lazy && r.params.lazy.enabled && r.lazy.load(), h) {
    g.init() && g.update(!0);
  }
  m && (r.controller.control = d.controller.control), x && (o && (d.pagination.el = o), p.init(), p.render(), p.update()), E && (a && (d.scrollbar.el = a), v.init(), v.updateSize(), v.setTranslate()), _ && (s && (d.navigation.nextEl = s), l && (d.navigation.prevEl = l), u.init(), u.update()), n.includes("allowSlideNext") && (r.allowSlideNext = i.allowSlideNext), n.includes("allowSlidePrev") && (r.allowSlidePrev = i.allowSlidePrev), n.includes("direction") && r.changeDirection(i.direction, !1), r.update();
}
function k(e, r) {
  return "undefined" == typeof window ? a(e, r) : o(e, r);
}
var I = d(null),
  V = d(null),
  z = function z() {
    return c(V);
  };
function A() {
  return A = Object.assign ? Object.assign.bind() : function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }
    return e;
  }, A.apply(this, arguments);
}
var B = p(function (e, r) {
  var _ref = void 0 === e ? {} : e,
    t = _ref.className,
    _ref$tag = _ref.tag,
    i = _ref$tag === void 0 ? "div" : _ref$tag,
    _ref$wrapperTag = _ref.wrapperTag,
    n = _ref$wrapperTag === void 0 ? "div" : _ref$wrapperTag,
    s = _ref.children,
    o = _ref.onSwiper,
    c = _objectWithoutProperties(_ref, _excluded),
    d = !1;
  var _u = u("swiper"),
    _u2 = _slicedToArray(_u, 2),
    p = _u2[0],
    g = _u2[1],
    _u3 = u(null),
    _u4 = _slicedToArray(_u3, 2),
    h = _u4[0],
    m = _u4[1],
    _u5 = u(!1),
    _u6 = _slicedToArray(_u5, 2),
    O = _u6[0],
    j = _u6[1],
    I = v(!1),
    z = v(null),
    B = v(null),
    G = v(null),
    T = v(null),
    D = v(null),
    L = v(null),
    M = v(null),
    $ = v(null),
    _ref2 = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        r = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
      var t = {
          on: {}
        },
        i = {},
        n = {};
      w(t, f.defaults), w(t, f.extendedDefaults), t._emitClasses = !0, t.init = !1;
      var s = {},
        l = S.map(function (e) {
          return e.replace(/_/, "");
        }),
        a = Object.assign({}, e);
      return Object.keys(a).forEach(function (a) {
        void 0 !== e[a] && (l.indexOf(a) >= 0 ? b(e[a]) ? (t[a] = {}, n[a] = {}, w(t[a], e[a]), w(n[a], e[a])) : (t[a] = e[a], n[a] = e[a]) : 0 === a.search(/on[A-Z]/) && "function" == typeof e[a] ? r ? i["".concat(a[2].toLowerCase()).concat(a.substr(3))] = e[a] : t.on["".concat(a[2].toLowerCase()).concat(a.substr(3))] = e[a] : s[a] = e[a]);
      }), ["navigation", "pagination", "scrollbar"].forEach(function (e) {
        !0 === t[e] && (t[e] = {}), !1 === t[e] && delete t[e];
      }), {
        params: t,
        passedParams: n,
        rest: s,
        events: i
      };
    }(c),
    H = _ref2.params,
    R = _ref2.passedParams,
    F = _ref2.rest,
    W = _ref2.events,
    _C = C(s),
    q = _C.slides,
    U = _C.slots,
    Z = function Z() {
      j(!O);
    };
  Object.assign(H.on, {
    _containerClasses: function _containerClasses(e, r) {
      g(r);
    }
  });
  var J = function J() {
    if (Object.assign(H.on, W), d = !0, B.current = new f(H), B.current.loopCreate = function () {}, B.current.loopDestroy = function () {}, H.loop && (B.current.loopedSlides = y(q, H)), B.current.virtual && B.current.params.virtual.enabled) {
      B.current.virtual.slides = q;
      var _e2 = {
        cache: !1,
        slides: q,
        renderExternal: m,
        renderExternalUpdate: !1
      };
      w(B.current.params.virtual, _e2), w(B.current.originalParams.virtual, _e2);
    }
  };
  z.current || J(), B.current && B.current.on("_beforeBreakpoint", Z);
  return a(function () {
    return function () {
      B.current && B.current.off("_beforeBreakpoint", Z);
    };
  }), a(function () {
    !I.current && B.current && (B.current.emitSlidesClasses(), I.current = !0);
  }), k(function () {
    if (r && (r.current = z.current), z.current) return B.current.destroyed && J(), function (e, r) {
      var t = e.el,
        i = e.nextEl,
        n = e.prevEl,
        s = e.paginationEl,
        l = e.scrollbarEl,
        a = e.swiper;
      x(r) && i && n && (a.params.navigation.nextEl = i, a.originalParams.navigation.nextEl = i, a.params.navigation.prevEl = n, a.originalParams.navigation.prevEl = n), E(r) && s && (a.params.pagination.el = s, a.originalParams.pagination.el = s), _(r) && l && (a.params.scrollbar.el = l, a.originalParams.scrollbar.el = l), a.init(t);
    }({
      el: z.current,
      nextEl: D.current,
      prevEl: L.current,
      paginationEl: M.current,
      scrollbarEl: $.current,
      swiper: B.current
    }, H), o && o(B.current), function () {
      B.current && !B.current.destroyed && B.current.destroy(!0, !1);
    };
  }, []), k(function () {
    !d && W && B.current && Object.keys(W).forEach(function (e) {
      B.current.on(e, W[e]);
    });
    var e = function (e, r, t, i, n) {
      var s = [];
      if (!r) return s;
      var l = function l(e) {
        s.indexOf(e) < 0 && s.push(e);
      };
      if (t && i) {
        var _e3 = i.map(n),
          _r = t.map(n);
        _e3.join("") !== _r.join("") && l("children"), i.length !== t.length && l("children");
      }
      return S.filter(function (e) {
        return "_" === e[0];
      }).map(function (e) {
        return e.replace(/_/, "");
      }).forEach(function (t) {
        if (t in e && t in r) if (b(e[t]) && b(r[t])) {
          var _i3 = Object.keys(e[t]),
            _n2 = Object.keys(r[t]);
          _i3.length !== _n2.length ? l(t) : (_i3.forEach(function (i) {
            e[t][i] !== r[t][i] && l(t);
          }), _n2.forEach(function (i) {
            e[t][i] !== r[t][i] && l(t);
          }));
        } else e[t] !== r[t] && l(t);
      }), s;
    }(R, G.current, q, T.current, function (e) {
      return e.key;
    });
    return G.current = R, T.current = q, e.length && B.current && !B.current.destroyed && N({
      swiper: B.current,
      slides: q,
      passedParams: R,
      changedParams: e,
      nextEl: D.current,
      prevEl: L.current,
      scrollbarEl: $.current,
      paginationEl: M.current
    }), function () {
      W && B.current && Object.keys(W).forEach(function (e) {
        B.current.off(e, W[e]);
      });
    };
  }), k(function () {
    var e;
    !(e = B.current) || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load(), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
  }, [h]), l.createElement(i, A({
    ref: z,
    className: P("".concat(p).concat(t ? " ".concat(t) : ""))
  }, F), l.createElement(V.Provider, {
    value: B.current
  }, U["container-start"], l.createElement(n, {
    className: "swiper-wrapper"
  }, U["wrapper-start"], H.virtual ? function (e, r, t) {
    if (!t) return null;
    var i = e.isHorizontal() ? _defineProperty({}, e.rtlTranslate ? "right" : "left", "".concat(t.offset, "px")) : {
      top: "".concat(t.offset, "px")
    };
    return r.filter(function (e, r) {
      return r >= t.from && r <= t.to;
    }).map(function (r) {
      return l.cloneElement(r, {
        swiper: e,
        style: i
      });
    });
  }(B.current, q, h) : !H.loop || B.current && B.current.destroyed ? q.map(function (e) {
    return l.cloneElement(e, {
      swiper: B.current
    });
  }) : function (e, r, t) {
    var i = r.map(function (r, t) {
      return l.cloneElement(r, {
        swiper: e,
        "data-swiper-slide-index": t
      });
    });
    function n(e, r, i) {
      return l.cloneElement(e, {
        key: "".concat(e.key, "-duplicate-").concat(r, "-").concat(i),
        className: "".concat(e.props.className || "", " ").concat(t.slideDuplicateClass)
      });
    }
    if (t.loopFillGroupWithBlank) {
      var _e4 = t.slidesPerGroup - i.length % t.slidesPerGroup;
      if (_e4 !== t.slidesPerGroup) for (var _r2 = 0; _r2 < _e4; _r2 += 1) {
        var _e5 = l.createElement("div", {
          className: "".concat(t.slideClass, " ").concat(t.slideBlankClass)
        });
        i.push(_e5);
      }
    }
    "auto" !== t.slidesPerView || t.loopedSlides || (t.loopedSlides = i.length);
    var s = y(i, t),
      a = [],
      o = [];
    for (var _e6 = 0; _e6 < s; _e6 += 1) {
      var _r3 = _e6 - Math.floor(_e6 / i.length) * i.length;
      o.push(n(i[_r3], _e6, "append")), a.unshift(n(i[i.length - _r3 - 1], _e6, "prepend"));
    }
    return e && (e.loopedSlides = s), [].concat(a, _toConsumableArray(i), o);
  }(B.current, q, H), U["wrapper-end"]), x(H) && l.createElement(l.Fragment, null, l.createElement("div", {
    ref: L,
    className: "swiper-button-prev"
  }), l.createElement("div", {
    ref: D,
    className: "swiper-button-next"
  })), _(H) && l.createElement("div", {
    ref: $,
    className: "swiper-scrollbar"
  }), E(H) && l.createElement("div", {
    ref: M,
    className: "swiper-pagination"
  }), U["container-end"]));
});
function G() {
  return G = Object.assign ? Object.assign.bind() : function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var i in t) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }
    return e;
  }, G.apply(this, arguments);
}
B.displayName = "Swiper";
var T = p(function (e, r) {
  var _ref4 = void 0 === e ? {} : e,
    _ref4$tag = _ref4.tag,
    t = _ref4$tag === void 0 ? "div" : _ref4$tag,
    i = _ref4.children,
    _ref4$className = _ref4.className,
    n = _ref4$className === void 0 ? "" : _ref4$className,
    s = _ref4.swiper,
    a = _ref4.zoom,
    o = _ref4.virtualIndex,
    c = _objectWithoutProperties(_ref4, _excluded2);
  var d = v(null),
    _u7 = u("swiper-slide"),
    _u8 = _slicedToArray(_u7, 2),
    p = _u8[0],
    f = _u8[1];
  function g(e, r, t) {
    r === d.current && f(t);
  }
  k(function () {
    if (r && (r.current = d.current), d.current && s) {
      if (!s.destroyed) return s.on("_slideClass", g), function () {
        s && s.off("_slideClass", g);
      };
      "swiper-slide" !== p && f("swiper-slide");
    }
  }), k(function () {
    s && d.current && !s.destroyed && f(s.getSlideClasses(d.current));
  }, [s]);
  var h = {
      isActive: p.indexOf("swiper-slide-active") >= 0 || p.indexOf("swiper-slide-duplicate-active") >= 0,
      isVisible: p.indexOf("swiper-slide-visible") >= 0,
      isDuplicate: p.indexOf("swiper-slide-duplicate") >= 0,
      isPrev: p.indexOf("swiper-slide-prev") >= 0 || p.indexOf("swiper-slide-duplicate-prev") >= 0,
      isNext: p.indexOf("swiper-slide-next") >= 0 || p.indexOf("swiper-slide-duplicate-next") >= 0
    },
    m = function m() {
      return "function" == typeof i ? i(h) : i;
    };
  return l.createElement(t, G({
    ref: d,
    className: P("".concat(p).concat(n ? " ".concat(n) : "")),
    "data-swiper-slide-index": o
  }, c), l.createElement(I.Provider, {
    value: h
  }, a ? l.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": "number" == typeof a ? a : void 0
  }, m()) : m()));
});
T.displayName = "SwiperSlide";
var D = function D(_ref5) {
    var t = _ref5.buttonPrev,
      i = _ref5.buttonNext,
      n = _ref5.isHideControls;
    var s = z();
    return n ? null : e("div", Object.assign({
      className: "cds-carousel__button-group"
    }, {
      children: [r(m, Object.assign({
        disabled: s.isBeginning,
        onClick: function onClick() {
          return s.slidePrev();
        },
        variant: "primary-icon"
      }, t, {
        iconPrefix: {
          props: {
            icon: "arrowLeft"
          }
        },
        className: "cds-carousel__button-group--prev"
      }, {
        children: t.children
      })), r(m, Object.assign({
        disabled: s.progress >= 1,
        onClick: function onClick() {
          return s.slideNext();
        },
        variant: "primary-icon"
      }, i, {
        iconPrefix: {
          props: {
            icon: "arrowRight"
          }
        }
      }, {
        children: i.children
      }))]
    }));
  },
  L = function L(_ref6) {
    var t = _ref6.progressIndicator,
      i = _ref6.isHideControls,
      n = _ref6.caption,
      s = _ref6.buttonNext,
      l = _ref6.buttonPrev,
      a = _ref6.totalItems,
      o = _ref6.activeSlide,
      c = _ref6.scrollClassName;
    return e("div", Object.assign({
      className: "cds-carousel__controllers cds-carousel__controllers--".concat(t)
    }, {
      children: ["caption" === t && r("div", Object.assign({
        className: "cds-carousel__caption-block"
      }, {
        children: r(h, {
          tag: "span",
          variant: "body",
          size: "xs",
          content: "".concat(o + 1, "/").concat(a, " ").concat(n || ""),
          className: "cds-carousel__caption-content"
        })
      })), "rails" === t && r("div", {
        className: "swiper-scrollbar ".concat(c)
      }), r(D, {
        buttonNext: s,
        buttonPrev: l,
        isHideControls: i
      }), r("noscript", {
        children: r("style", {
          children: "\n  .swiper-scrollbar {\n    display: none;\n  }\n  .cds-carousel__button-group {\n    display: none;\n  }\n"
        })
      })]
    }));
  },
  M = function M(_ref7) {
    var e = _ref7.index,
      r = _ref7.children,
      t = _ref7.variant,
      i = _ref7.slidesPerView;
    var n = z(),
      s = n.activeIndex,
      l = n.previousIndex,
      o = n.params,
      c = n.slides,
      d = n.isEnd;
    return a(function () {
      var r = null == c ? void 0 : c[e],
        a = null == r ? void 0 : r.querySelector("a, button");
      (function (_ref8) {
        var e = _ref8.activeEl,
          r = _ref8.activeIndex,
          t = _ref8.index,
          i = _ref8.previousIndex,
          n = _ref8.slidesPerView,
          s = _ref8.slidesLength;
        return !(s <= n || !e || r !== t || void 0 === i);
      })({
        activeEl: a,
        activeIndex: s,
        index: e,
        previousIndex: l,
        slidesPerView: i,
        slidesLength: c.length
      }) && setTimeout(function () {
        a.focus();
      }, 100);
      var o = function (_ref9) {
        var e = _ref9.slidesPerView,
          r = _ref9.elementIndex,
          t = _ref9.visibleSlidesIndexes,
          i = _ref9.variant,
          n = _ref9.isEnd,
          s = _ref9.activeIndex;
        if ("fixed" === i) {
          if (e === t.length) return !1;
          if (n) return t[0] === r;
          var _i4 = t.indexOf(s);
          return !(0 === _i4 ? t.slice(0, -1) : t.slice(_i4)).includes(r);
        }
        return 1.2 === e && r !== s;
      }({
        slidesPerView: i,
        elementIndex: e,
        variant: t,
        visibleSlidesIndexes: n.visibleSlidesIndexes,
        isEnd: d,
        activeIndex: s
      });
      if (r && (!r.className.includes("swiper-slide-visible") || o)) {
        var _e7 = r.querySelectorAll("a, button, article");
        return p = _e7, r.setAttribute("aria-hidden", "true"), p.forEach(function (e) {
          e.setAttribute("tabIndex", "-1"), e.setAttribute("aria-hidden", "true"), e.style.pointerEvents = "none";
        }), function () {
          r.removeAttribute("aria-hidden"), _e7.forEach(function (e) {
            e.removeAttribute("tabIndex"), e.removeAttribute("aria-hidden"), e.style.pointerEvents = "auto";
          });
        };
      }
      var p;
    }, [s, e, o, l, c, i, t, d]), r;
  },
  $ = function $(_ref10) {
    var _breakpoints;
    var e = _ref10.variant,
      r = _ref10.gap,
      t = _ref10.preferredCardSize;
    if ("fixed" === e) return {
      slidesPerView: "auto",
      slidesPerGroupAuto: !0
    };
    if ("single" === e) return {
      breakpoints: {
        360: {
          slidesPerView: 1,
          spaceBetween: r,
          slidesPerGroup: 1
        }
      }
    };
    return {
      breakpoints: (_breakpoints = {
        320: {
          slidesPerView: 1.2,
          spaceBetween: r,
          slidesPerGroup: 1
        }
      }, _defineProperty(_breakpoints, 2 * t + 2 * r + 40, {
        slidesPerView: 2,
        spaceBetween: r,
        slidesPerGroup: 2
      }), _defineProperty(_breakpoints, 3 * t + 3 * r + 40, {
        slidesPerView: 3,
        spaceBetween: r,
        slidesPerGroup: 3
      }), _defineProperty(_breakpoints, 4 * t + 4 * r + 40, {
        slidesPerView: 4,
        spaceBetween: r,
        slidesPerGroup: 4
      }), _breakpoints)
    };
  },
  H = function H(e, r, t) {
    var i = (e + r) / (t + r);
    return i % 1 > .8 ? Math.round(i) : Math.floor(i);
  },
  R = p(function (l, o) {
    var c, d;
    var p = l.className,
      f = l.items,
      _l$progressIndicator = l.progressIndicator,
      h = _l$progressIndicator === void 0 ? "none" : _l$progressIndicator,
      _l$variant = l.variant,
      m = _l$variant === void 0 ? "fixed" : _l$variant,
      _l$gap = l.gap,
      b = _l$gap === void 0 ? 32 : _l$gap,
      _l$wrapperTag = l.wrapperTag,
      w = _l$wrapperTag === void 0 ? "ul" : _l$wrapperTag,
      _l$tag = l.tag,
      x = _l$tag === void 0 ? "li" : _l$tag,
      E = l.buttonNext,
      _ = l.buttonPrev,
      _l$preferredCardSize = l.preferredCardSize,
      P = _l$preferredCardSize === void 0 ? 300 : _l$preferredCardSize,
      S = l.ariaLivePlaceholder,
      y = "scroll-".concat(s(Object.assign(Object.assign({}, l), {
        items: l.items.map(function (_ref11) {
          var e = _ref11.caption;
          return e;
        })
      }))),
      _u9 = u({
        progress: 0,
        activeSlide: 0,
        slidesPerView: 0
      }),
      _u10 = _slicedToArray(_u9, 2),
      O = _u10[0],
      j = _u10[1],
      C = v(),
      N = t();
    a(function () {
      var e;
      null === (e = C.current) || void 0 === e || e.changeLanguageDirection(N);
    }, [N]);
    return e("div", Object.assign({
      ref: o,
      className: n("cds-carousel", p)
    }, {
      children: [e(B, Object.assign({
        onSwiper: function onSwiper(e) {
          C.current = e;
        },
        wrapperTag: w,
        slidesPerView: "auto",
        watchSlidesProgress: !0,
        spaceBetween: b,
        centerInsufficientSlides: !0,
        shortSwipes: !1,
        modules: [g],
        scrollbar: {
          el: ".".concat(y || "swiper-scrollbar")
        }
      }, $({
        variant: m,
        gap: b,
        preferredCardSize: P
      }), {
        onProgress: function onProgress(e) {
          if ("fixed" === m && !O.slidesPerView) {
            var _r4 = H(e.width, b, P);
            j(function (e) {
              return Object.assign(Object.assign({}, e), {
                slidesPerView: _r4
              });
            });
          }
          j(function (r) {
            return Object.assign(Object.assign({}, r), {
              progress: Math.abs(e.progress)
            });
          });
        },
        onSlideChange: function onSlideChange(e) {
          j(function (r) {
            return Object.assign(Object.assign({}, r), {
              activeSlide: e.activeIndex
            });
          });
        },
        onBreakpoint: function onBreakpoint(e, r) {
          j(function (e) {
            return Object.assign(Object.assign({}, e), {
              slidesPerView: Number(r.slidesPerView)
            });
          });
        },
        onResize: function onResize(e) {
          if ("fixed" === m) {
            var _r5 = H(e.width, b, P);
            j(function (e) {
              return Object.assign(Object.assign({}, e), {
                slidesPerView: _r5
              });
            });
          }
        }
      }, {
        children: [f.map(function (_ref12, t) {
          var e = _ref12.children;
          return r(T, Object.assign({
            style: {
              width: "fixed" === m ? P : "100%"
            },
            tag: x,
            className: "cds-carousel-slide--".concat(m)
          }, {
            children: r(M, Object.assign({
              index: t,
              variant: m,
              slidesPerView: O.slidesPerView
            }, {
              children: e
            }))
          }), "swiper-slide".concat(t.toString()));
        }), r("div", Object.assign({
          "aria-live": "polite",
          className: "cds-carousel__sr-only"
        }, {
          children: S(O.activeSlide + 1, f.length, O.slidesPerView, O.progress)
        })), f && f.length > 1 && i() ? r(L, {
          progressIndicator: h,
          isHideControls: (null === (c = C.current) || void 0 === c ? void 0 : c.isLocked) || !1,
          totalItems: f.length,
          activeSlide: O.activeSlide,
          caption: null === (d = f[O.activeSlide]) || void 0 === d ? void 0 : d.caption,
          buttonNext: E,
          buttonPrev: _,
          scrollClassName: y
        }) : null]
      })), r("noscript", {
        children: r("style", {
          children: ".swiper-wrapper {\n                  gap: ".concat(b, "px;\n            }\n            \n            .cds-carousel-slide--fixed,\n            .cds-carousel-slide--fluid {\n              width: ").concat(P, "px !important;\n            }")
        })
      })]
    }));
  });
export { R as Carousel };